import React, { Component, lazy, Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Loading from './share/Loading';
import { withStyles } from '@material-ui/core/styles';
import CaixaSaudePrincipal from './caixaSaude/CaixaSaudePrincipal';
import GerarArquivoBenef from './caixaSaude/GerarArquivoBenef';
import ArquivoInclusao from './caixaSaude/ArquivoInclusao';
import ArquivoExclusao from './caixaSaude/ArquivoExclusao';
import EnvioArquivoFaturamento from './caixaSaude/EnvioArquivoFaturamento';
import CalculoCoparticipacaoCaixa from './caixaSaude/CalculoCoparticipacaoCaixa';
import PesquisaArquivosCaixa from './caixaSaude/PesquisaArquivosCaixa';
import ArquivoAlteracao from './caixaSaude/ArquivoAlteracao';
import AuxilioSaude from './financeiro/AuxilioSaude';
import VigenciaSeguroConsulta from './tabelasApoio/vigenciaSeguro/VigenciaSeguroConsulta';
import DividasEmAbertoPorPeriodo from './relatorios/DividasEmAbertoPorPeriodo';
import LoteRecursoGlosa from './arquivosXML/LoteRecursoGlosa';
import TaxasCadastro from './tabelasApoio/taxas/TaxasCadastro';
import PesquisaArquivosBenner from './orcamento/PesquisaArquivosBenner';

const ItemTabelaConsulta = lazy(() => import ('./arquivosXML/ItemTabelaConsulta'));
const FluxoPensionista = lazy(() => import ('./consultas/FluxoPensionista'));
const AcertoCoparticipacao = lazy(() => import ('./financeiro/AcertoCoparticipacao'));
const AcertoMensalidade = lazy(() => import ('./financeiro/AcertoMensalidade'));
const AcertosDiversos = lazy(() => import ('./financeiro/AcertosDiversos'));
const AssistenciaOdonto = lazy(() => import ('./financeiro/AssistenciaOdonto'));
const CadastroReembolso = lazy(() => import ('./financeiro/CadastroReembolso'));
const CalculoCoparticipacao = lazy(() => import ('./financeiro/CalculoCoparticipacao'));
const CalculoCoparticipacaoOdonto = lazy(() => import ('./financeiro/CalculoCoparticipacaoOdonto'));
const DentistaCadastro = lazy(() => import ('./financeiro/DentistaCadastro'));
const DividaServDesligado = lazy(() => import ('./financeiro/DividaServDesligado'));
const DividaServDesligadoPagto = lazy(() => import ('./financeiro/DividaServDesligadoPagto'));
const FinanceiroPrincipal = lazy(() => import ('./financeiro/FinanceiroPrincipal'));
const ProfissionalCadastro = lazy(() => import ('./odontologico/ProfissionalCadastro'));
const ProfissionalPrincipal = lazy(() => import ('./odontologico/ProfissionalPrincipal'));
const PrestadorOrgaoExterno = lazy(() => import ('./prestador/PrestadorOrgaoExterno'));
const CalculoAtuarial = lazy(() => import ('./relatorios/CalculoAtuarial'));
const DividasEmAbertoDetalhado = lazy(() => import ('./relatorios/DividasEmAbertoDetalhado'));
const Reembolso = lazy(() => import ('./relatorios/Reembolso'));
const RelatorioBeneficiarios = lazy(() => import ('./relatorios/RelatorioBeneficiarios'));
const Unauthorized = lazy(() => import ('./share/Unauthorized'));
const FaixaEtariaCadastro = lazy(() => import ('./tabelasApoio/faixaEtaria/FaixaEtariaCadastro'));
const FaixaRemuneracaoCadastro = lazy(() => import ('./tabelasApoio/faixaRemuneracao/FaixaRemuneracaoCadastro'));
const LimiteCobrancaCadastro = lazy(() => import ('./tabelasApoio/limiteCobranca/LimiteCobrancaCadastro'));
const MensalidadeCadastro = lazy(() => import ('./tabelasApoio/mensalidade/MensalidadeCadastro'));
const ParametrosApoio = lazy(() => import ('./tabelasApoio/parametrosSistema/Parametros'));
const TabelasApoioPrincipal = lazy(() => import ('./tabelasApoio/TabelasApoioPrincipal'));
const TipoMensalidadeCadastro = lazy(() => import ('./tabelasApoio/tipoMensalidade/TipoMensalidadeCadastro'));
const VigenciaPorteCadastro = lazy(() => import ('./tabelasApoio/vigenciaPorte/VigenciaPorteCadastro'));
const ArquivosXMLPrincipal = lazy(() => import('./arquivosXML/ArquivosXMLPrincipal'));
const ArquivosXMLPrincipalUnimed = lazy(() => import('./arquivosXML/ArquivosXMLPrincipalUnimed'));
const EnvioArquivo = lazy(() => import('./arquivosXML/EnvioArquivo'));
const EnvioArquivoUnimed = lazy(() => import('./arquivosXML/EnvioArquivoUnimed'));
const ImpressaoProtocolo = lazy(() => import('./arquivosXML/ImpressaoProtocolo'));
const ValidacaoPrevia = lazy(() => import('./arquivosXML/ValidacaoPrevia'));
const AuditoriaPrincipal = lazy(() => import('./auditoria/AuditoriaPrincipal'));
const FaturasAguardandoLiberacao = lazy(() => import('./auditoria/FaturasAguardandoLiberacao'));
const FaturasConsultarTodas = lazy(() => import('./auditoria/FaturasConsultar'));
const FaturasEmAuditoria = lazy(() => import('./auditoria/FaturasEmAuditoria'));
const FaturasLiberadasParaPagamento = lazy(() => import('./auditoria/FaturasLiberadasParaPagamento'));
const FaturasSemAuditoria = lazy(() => import('./auditoria/FaturasSemAuditoria'));
const FaturasSemData = lazy(() => import('./auditoria/FaturasSemData'));
const FaturasEmAvaliacaoCNU = lazy(() => import('./auditoriaCNU/FaturasEmAvaliacaoCNU'));
const FaturasAvaliacaoCNUFinalizada = lazy(() => import('./auditoriaCNU/FaturasAvaliacaoCNUFinalizada'));
const BeneficiarioCadastro = lazy(() => import('./beneficiario/BeneficiarioCadastro'));
const BeneficiarioPrincipal = lazy(() => import('./beneficiario/BeneficiarioPrincipal'));
const Fluxo = lazy(() => import('./beneficiario/Fluxo'));
const ConsultaPrincipal = lazy(() => import('./consultas/ConsultaPrincipal'));
const Extratos = lazy(() => import('./consultas/Extratos'));
const ProdutividadeAuditoria = lazy(() => import('./consultas/ProdutividadeAuditoria'));
const Dashboard = lazy(() => import('./dashboard/Dashboard'));
const ExtratoCoparticipacao = lazy(() => import('./extrato/ExtratoCoparticipacao'));
const ExtratoMensalidade = lazy(() => import('./extrato/ExtratoMensalidade'));
const Creditos = lazy(() => import('./orcamento/Creditos'));
const DemonstrativoCadastro = lazy(() => import('./orcamento/DemonstrativoCadastro'));
const Grafico = lazy(() => import('./orcamento/Grafico'));
const OrcamentoPrincipal = lazy(() => import('./orcamento/OrcamentoPrincipal'));
const GrupoPrestador = lazy(() => import('./prestador/GrupoPrestador'));
const PrestadorCadastro = lazy(() => import('./prestador/PrestadorCadastro'));
const PrestadorPrincipal = lazy(() => import('./prestador/PrestadorPrincipal'));
const DividasEmAberto = lazy(() => import('./relatorios/DividasEmAberto'));
const Mensalidades = lazy(() => import('./relatorios/Mensalidades'));
const Coparticipacoes = lazy(() => import('./relatorios/Coparticipacoes'));
const RelatorioPrincipal = lazy(() => import('./relatorios/RelatorioPrincipal'));
const DeclaracaoDeGastos = lazy(() => import('./relatorios/DeclaracaoDeGastos'));

const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  root: {
    paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },...theme.mixins.gutters(),
    width: '100%',
    flexGrow: 1,
    marginTop: theme.spacing(4),
    height: '100%',
    overflow: 'auto',
  },
});

class PageContent extends Component {
  render () {
    const { classes } = this.props;

    return (
      <main className={classes.root}>
        <div className={classes.appBarSpacer} />
        <Suspense fallback={<Loading loading message={'Carregando...'} />}>
          <Switch>
            <Route exact path='/dashboard' render={() => <Dashboard />} />
            <Route exact path='/beneficiario' render={() => <BeneficiarioPrincipal />} />
            <Route exact path='/orcamento' render={() => <OrcamentoPrincipal />} />
            <Route exact path='/prestador' render={() => <PrestadorPrincipal />} />
            <Route exact path='/relatorio' render={() => <RelatorioPrincipal />} />
            <Route exact path='/consulta' render={() => <ConsultaPrincipal />} />
            <Route exact path='/relatorio/dividas' render={() => <DividasEmAberto />} />
            <Route exact path='/relatorio/dividas_detalhado' render={() => <DividasEmAbertoDetalhado />} />
            <Route exact path='/relatorio/dividas_periodo' render={() => <DividasEmAbertoPorPeriodo />} />
            <Route exact path='/relatorio/mensalidades' render={() => <Mensalidades />} />
            <Route exact path='/relatorio/coparticipacoes' render={() => <Coparticipacoes />} />
            <Route exact path='/relatorio/calculo_atuarial' render={() => <CalculoAtuarial />} />
            <Route exact path='/relatorio/relatorio_beneficiarios' render={() => <RelatorioBeneficiarios />} />
            <Route exact path='/relatorio/declaracao_de_gastos' render={() => <DeclaracaoDeGastos />} />
            <Route exact path='/relatorio/reembolso' render={() => <Reembolso />} />
            <Route exact path='/arquivoXML' render={() => <ArquivosXMLPrincipal />} />
            <Route exact path='/arquivoXMLUnimed' render={() => <ArquivosXMLPrincipalUnimed />} />
            <Route exact path='/caixaSaude' render={() => <CaixaSaudePrincipal />} />
            <Route exact path='/caixaSaude/arquivoBenef' render={() => <GerarArquivoBenef />} />
            <Route exact path='/caixaSaude/arquivoInclusao' render={() => <ArquivoInclusao />} />
            <Route exact path='/caixaSaude/arquivoExclusao' render={() => <ArquivoExclusao />} />
            <Route exact path='/caixaSaude/arquivoAlteracao' render={() => <ArquivoAlteracao />} />
            <Route exact path='/caixaSaude/pesquisaArquivos' render={() => <PesquisaArquivosCaixa />} />
            <Route exact path='/caixaSaude/calculoCoparticipacao' render={() => <CalculoCoparticipacaoCaixa />} />
            <Route exact path='/auditoria' render={() => <AuditoriaPrincipal />} />
            <Route exact path='/caixaSaude/envioArquivoFaturamento' render={() => <EnvioArquivoFaturamento />} />
            <Route exact path='/tabelasApoio' render={() => <TabelasApoioPrincipal />} />
            <Route exact path='/odontologico' render={() => <ProfissionalPrincipal />} />
            <Route exact path='/financeiro' render={() => <FinanceiroPrincipal />} />
            <Route exact path='/beneficiario/fluxo' render={() => <Fluxo />} />
            <Route exact path='/beneficiario/cadastro' render={() => <BeneficiarioCadastro />} />
            <Route exact path='/orcamento/creditos' render={() => <Creditos />} />
            <Route exact path='/orcamento/demonstrativo' render={() => <DemonstrativoCadastro />} />
            <Route exact path='/orcamento/grafico' render={() => <Grafico />} />
            <Route exact path='/orcamento/pesquisaArquivosBenner' render={() => <PesquisaArquivosBenner />} />
            <Route exact path='/extrato/coparticipacao' render={() => <ExtratoCoparticipacao />} />
            <Route exact path='/extrato/mensalidade' render={() => <ExtratoMensalidade />} />
            <Route exact path='/arquivoXML/validacao' render={() => <ValidacaoPrevia />} />
            <Route exact path='/arquivoXML/envio' render={() => <EnvioArquivo />} />
            <Route exact path='/arquivoXML/impressao' render={() => <ImpressaoProtocolo />} />
            <Route exact path='/arquivoXML/lote_recurso' render={() => <LoteRecursoGlosa />} />
            {/* <Route exact path='/arquivoXML/lotes' render={() => <Lotes />} /> */}
            <Route exact path='/arquivoXML/envioUnimed' render={() => <EnvioArquivoUnimed />} />
            <Route exact path='/arquivoXML/item_tabela' render={() => <ItemTabelaConsulta />} />
            <Route exact path='/auditoria/faturas_sem_data' render={() => <FaturasSemData />} />
            <Route exact path='/auditoria/faturas_sem_auditoria' render={() => <FaturasSemAuditoria />} />
            <Route exact path='/auditoria/faturas_em_auditoria' render={() => <FaturasEmAuditoria />} />
            <Route exact path='/auditoria/faturas_auditadas' render={() => <FaturasAguardandoLiberacao />} />
            <Route exact path='/auditoria/faturas_liberadas' render={() => <FaturasLiberadasParaPagamento />} />
            <Route exact path='/auditoria/consultar' render={() => <FaturasConsultarTodas />} />
            <Route exact path='/auditoria/faturas_em_avaliacao_CNU' render={() => <FaturasEmAvaliacaoCNU />} />
            <Route exact path='/auditoria/faturas_avaliacao_CNU_finalizada' render={() => <FaturasAvaliacaoCNUFinalizada />} />
            <Route exact path='/consulta/fluxo' render={() => <Fluxo />} />
            <Route exact path='/consulta/extratos' render={() => <Extratos />} />
            <Route exact path='/consulta/produtividade' render={() => <ProdutividadeAuditoria />} />
            <Route exact path='/consulta/fluxoPensionista' render={() => <FluxoPensionista />} />
            <Route exact path='/prestador/grupo' render={() => <GrupoPrestador />} />
            <Route exact path='/prestador/cadastro' render={() => <PrestadorCadastro />} />
            <Route exact path='/prestador/orgao_externo' render={() => <PrestadorOrgaoExterno />} />
            <Route exact path='/financeiro/assistenciaOdontologica' render={() => <AssistenciaOdonto />} />
            <Route exact path='/financeiro/dentista' render={() => <DentistaCadastro />} />
            <Route exact path='/odontologico/cadastro' render={() => <ProfissionalCadastro />} />
            <Route exact path='/tabelasApoio/parametros' render={() => <ParametrosApoio />} />
            <Route exact path='/tabelasApoio/faixaRemuneracao' render={() => <FaixaRemuneracaoCadastro />} />
            <Route exact path='/tabelasApoio/faixaEtaria' render={() => <FaixaEtariaCadastro />} />
            <Route exact path='/tabelasApoio/tipoMensalidade' render={() => <TipoMensalidadeCadastro />} />
            <Route exact path='/tabelasApoio/mensalidade' render={() => <MensalidadeCadastro />} />
            <Route exact path='/tabelasApoio/limiteCobranca' render={() => <LimiteCobrancaCadastro />} />
            <Route exact path='/tabelasApoio/vigenciaPorte' render={() => <VigenciaPorteCadastro />} />
            <Route exact path='/tabelasApoio/vigenciaSeguro' render={() => <VigenciaSeguroConsulta />} />
            <Route exact path='/tabelasApoio/taxas' render={() => <TaxasCadastro />} />
            <Route exact path='/financeiro/calculoCoparticipacao' render={() => <CalculoCoparticipacao />} />            
            <Route exact path='/financeiro/calculoCoparticipacaoOdonto' render={() => <CalculoCoparticipacaoOdonto />} />
            <Route exact path='/financeiro/acertoMensalidade' render={() => <AcertoMensalidade />} />
            <Route exact path='/financeiro/acertoCoparticipacao' render={() => <AcertoCoparticipacao />} />
            <Route exact path='/financeiro/acertosDiversos' render={() => <AcertosDiversos />} />
            <Route exact path='/financeiro/auxilioSaude' render={() => <AuxilioSaude />} />
            <Route exact path='/financeiro/dividaServDesligado' render={() => <DividaServDesligado />} />
            <Route exact path='/financeiro/dividaServDesligadoPagto' render={() => <DividaServDesligadoPagto />} />
            <Route exact path='/financeiro/reembolsoMedico' render={() => <CadastroReembolso />} />
            <Route exact path='/unauthorized' render={() => <Unauthorized />} />
            <Route exact path='/' render={() => (<Redirect to='/dashboard' />)} />
          </Switch>
        </Suspense>
      </main>
    );
  }
}
export default withStyles(styles)(PageContent);
